var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgService4 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 176,
    height: 175,
    viewBox: "0 0 176 175",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 173,
    height: 172,
    rx: 18.5,
    stroke: "url(#paint0_linear_1537_1324)",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41 100L45.6154 127.586M45.6154 127.586V148M45.6154 127.586H62.2308M65 127.586H62.2308M62.2308 127.586V148",
    stroke: "url(#paint1_linear_1537_1324)",
    strokeWidth: 5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M140 100L135.192 127.586M135.192 127.586V148M135.192 127.586H117.885M115 127.586H117.885M117.885 127.586V148",
    stroke: "url(#paint2_linear_1537_1324)",
    strokeWidth: 5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M90.2793 26C84.7868 29.5443 73.1315 39.8789 70.4505 52.8624C76.5946 51.1835 93.1279 48.833 110.108 52.8624C108.619 47.8257 102.568 35.4018 90.2793 26Z",
    fill: "url(#paint3_linear_1537_1324)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M96.7027 26C102.102 31.4098 113.459 44.5798 115.694 53.9817C120.162 52.6758 133.121 50.6239 149.207 52.8624C141.574 45.5872 120.386 30.0294 96.7027 26Z",
    fill: "url(#paint4_linear_1537_1324)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M152 61.8165V57.8991C149.766 57.3394 143.175 56.1083 134.685 55.6605C126.195 55.2128 118.486 57.3394 115.694 58.4587V61.8165C119.604 60.8838 128.764 59.1303 134.126 59.578C139.488 60.0257 148.276 61.2569 152 61.8165Z",
    fill: "url(#paint5_linear_1537_1324)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3333 61.8165C73.2432 60.6972 82.9063 58.4587 90.2793 58.4587C97.6523 58.4587 107.688 60.6972 111.784 61.8165V57.8991C108.246 56.9664 98.9928 55.1009 90.2793 55.1009C81.5658 55.1009 72.6847 56.9664 69.3333 57.8991V61.8165Z",
    fill: "url(#paint6_linear_1537_1324)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3063 61.8165V57.8991C62.0721 57.3394 55.4811 56.1083 46.991 55.6605C38.5009 55.2128 30.7928 57.3394 28 58.4587V61.8165C31.9099 60.8838 41.0703 59.1303 46.4324 59.578C51.7946 60.0257 60.5826 61.2569 64.3063 61.8165Z",
    fill: "url(#paint7_linear_1537_1324)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M65.982 53.9817C67.0991 48.3853 72.2378 34.9541 83.8559 26C61.5135 30.0294 39.1712 45.5872 30.7928 52.8624C35.8198 51.6762 49.8955 50.2393 65.982 53.9817Z",
    fill: "url(#paint8_linear_1537_1324)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M90.2793 60.6972H88.8829V106.028H91.6757V60.6972H90.2793Z",
    fill: "url(#paint9_linear_1537_1324)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7207 108.826V107.706H120.721V109.945H58.7207V108.826Z",
    fill: "url(#paint10_linear_1537_1324)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M88.8829 111.624V145.202H76.5946V148H103.964V145.202H91.6757V111.624H88.8829Z",
    fill: "url(#paint11_linear_1537_1324)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7207 107.706V108.826V109.945M58.7207 107.706H120.721V109.945H58.7207M58.7207 107.706V109.945M90.2793 60.6972H88.8829V106.028H91.6757V60.6972H90.2793ZM69.3333 61.8165C73.2432 60.6972 82.9063 58.4587 90.2793 58.4587C97.6523 58.4587 107.688 60.6972 111.784 61.8165V57.8991C108.246 56.9664 98.9928 55.1009 90.2793 55.1009C81.5658 55.1009 72.6847 56.9664 69.3333 57.8991V61.8165ZM64.3063 61.8165V57.8991C62.0721 57.3394 55.4811 56.1083 46.991 55.6605C38.5009 55.2128 30.7928 57.3394 28 58.4587V61.8165C31.9099 60.8838 41.0703 59.1303 46.4324 59.578C51.7946 60.0257 60.5826 61.2569 64.3063 61.8165ZM152 61.8165V57.8991C149.766 57.3394 143.175 56.1083 134.685 55.6605C126.195 55.2128 118.486 57.3394 115.694 58.4587V61.8165C119.604 60.8838 128.764 59.1303 134.126 59.578C139.488 60.0257 148.276 61.2569 152 61.8165ZM96.7027 26C102.102 31.4098 113.459 44.5798 115.694 53.9817C120.162 52.6758 133.121 50.6239 149.207 52.8624C141.574 45.5872 120.386 30.0294 96.7027 26ZM90.2793 26C84.7868 29.5443 73.1315 39.8789 70.4505 52.8624C76.5946 51.1835 93.1279 48.833 110.108 52.8624C108.619 47.8257 102.568 35.4018 90.2793 26ZM65.982 53.9817C67.0991 48.3853 72.2378 34.9541 83.8559 26C61.5135 30.0294 39.1712 45.5872 30.7928 52.8624C35.8198 51.6762 49.8955 50.2393 65.982 53.9817ZM88.8829 111.624V145.202H76.5946V148H103.964V145.202H91.6757V111.624H88.8829Z",
    stroke: "url(#paint12_linear_1537_1324)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1537_1324",
    x1: 88,
    y1: 0,
    x2: 88,
    y2: 175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E90AA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1537_1324",
    x1: 53,
    y1: 100,
    x2: 53,
    y2: 148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E90AA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1537_1324",
    x1: 127.5,
    y1: 100,
    x2: 127.5,
    y2: 148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E90AA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1537_1324",
    x1: 90,
    y1: 26,
    x2: 90,
    y2: 148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E90AA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1537_1324",
    x1: 90,
    y1: 26,
    x2: 90,
    y2: 148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E90AA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1537_1324",
    x1: 90,
    y1: 26,
    x2: 90,
    y2: 148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E90AA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1537_1324",
    x1: 90,
    y1: 26,
    x2: 90,
    y2: 148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E90AA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1537_1324",
    x1: 90,
    y1: 26,
    x2: 90,
    y2: 148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E90AA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1537_1324",
    x1: 90,
    y1: 26,
    x2: 90,
    y2: 148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E90AA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1537_1324",
    x1: 90,
    y1: 26,
    x2: 90,
    y2: 148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E90AA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1537_1324",
    x1: 90,
    y1: 26,
    x2: 90,
    y2: 148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E90AA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1537_1324",
    x1: 90,
    y1: 26,
    x2: 90,
    y2: 148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E90AA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1537_1324",
    x1: 90,
    y1: 26,
    x2: 90,
    y2: 148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E90AA"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgService4);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/service4.9803d9a0611e47e69c78dabae26e0adc.svg";